import React, {useMemo} from 'react';
import {useFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import {DateCell} from "../../../components/common/advance-table/CustomCells";
import {Card} from "react-bootstrap";
import CardTableHeader from "../../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../../components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../../../components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "../../../components/common/advance-table/AdvanceTableWrapper";
import {useUser} from "../../../hooks/useUser";
import NewPractitionerIdentifierModal from "./NewPractitionerIdentifierModal";
import EditPractitionerIdentifierModal from "./EditPractitionerIdentifierModal";
import DeleteModal from "../../../components/common/modals/DeleteModal";
import {useTableModals} from "../../../hooks/useTableModals";

const cols = [
    {accessor: 'identifierType.display', Header: 'System'},
    {accessor: 'identifierUseCode.display', Header:'Use'},
    {accessor: 'value', Header: 'Value'},
    {accessor: 'effectiveFrom', Header: "Effective From", Cell: DateCell},
    {accessor:'effectiveTo', Header:'Effective To', Cell: DateCell}
    ];
const PractitionerIdentifiers = ({practitionerId, identifiers,  allIdentifierTypes, allIdentifierUseCodes, displayMode}) => {
    const deleteMutation = graphql`
    mutation PractitionerIdentifiersDeleteMutation($id: ID!) {
        deleteNode(input: {id: $id}) {
            deletedNodeId @deleteRecord
            owner {
                ... on Practitioner {
                    id
                    identifiers {
                        id
                    }
                }
            }
        }
    }`
    const data = useFragment(graphql`
        fragment PractitionerIdentifiers_Identifiers on PractitionerIdentifier @relay(plural:true) {
            id
            identifierType {
                display
                id
            }
            identifierUseCode {
                display
                id
            }
            value
            effectiveFrom
            effectiveTo
        }
    `, identifiers)
    const activeCols = useMemo(() => displayMode === "current" ? cols.slice(0, -2) : cols, [displayMode]);
    const {hasPermission} = useUser();
    const {selected, columns, newModal, editModal, deleteModal} = useTableModals(activeCols, "PractitionerIdentifier.Update", "PractitionerIdentifier.Delete");

    return (
        <>
            <AdvanceTableWrapper columns={columns}
                                 data={data}
                                 sortable
                                 pagination
                                 perPage={10}
            >
                <Card className={"mb-3"}>
                    <Card.Header>
                        <CardTableHeader onNewClick={newModal.onClick}
                                         title={"Identifiers"}
                                         table
                                         showNew={hasPermission("PractitionerIdentifier.Create")} />
                    </Card.Header>
                    <Card.Body className={"p-0"}>
                        <AdvanceTable table
                                      headerClassName={"bg-200 text-900 text-nowrap align-middle"}
                                      rowClassName={"align-middle white-space-nowrap"}
                                      tableProps={{size: "sm", striped: true, className: "fs--1 mb-0 overflow-hidden"}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTablePagination table />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <NewPractitionerIdentifierModal showModal={newModal.showModal} 
                                            onClose={newModal.onClose}
                                            identifierTypes={allIdentifierTypes}
                                            identifierUseCodes={allIdentifierUseCodes}
                                            practitionerId={practitionerId}
            />
            {selected && <EditPractitionerIdentifierModal showModal={editModal.showModal} 
                                                          onClose={editModal.onClose}
                                                          selectedIdentifier={selected}
                                                          identifierTypes={allIdentifierTypes}
                                                          identifierUseCodes={allIdentifierUseCodes}
            />}
            {selected && <DeleteModal mutation={deleteMutation} 
                                      onClose={deleteModal.onClose}
                                      thingToDelete={"Identifier"} 
                                      showModal={deleteModal.showModal} 
                                      id={selected.id}>
                <p>This action cannot be undone.</p>
            </DeleteModal>}
        </>
    )
}
export default PractitionerIdentifiers